import { Component, ViewChild, ElementRef, AfterViewInit , OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import * as _ from 'lodash';
import { ApiService } from '../../api/api.service';
import { first } from 'rxjs/operators';
import { result } from 'lodash';
import { Router } from '@angular/router';


@Component({
  selector: 'app-testotr',
  templateUrl: './testotr.component.html',
  styleUrls: ['./testotr.component.css']
})
export class TestotrComponent implements OnInit {


  public registerForm:any;
  submitted = false;

  constructor(
    private http: HttpClient,
    private formBuilder: FormBuilder,
    private api: ApiService,
    private router: Router,
  ) { }

  ngOnInit(): void {

    this.registerForm = this.formBuilder.group({
      name: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      mobile: ['', [Validators.required, Validators.minLength(10)]],
      password: ['', Validators.required],
      cn_password: ['', Validators.required],
    }, {
      validator: this.MustMatch('password', 'cn_password')
    })


  }



  get f() { return this.registerForm.controls; }

onRegSubmit(){
  console.log(this.registerForm.value);

  this.submitted = true;

  // stop here if form is invalid
  if (this.registerForm.invalid) {
      return;
  }

  this.api.regFormApplyCheck(this.registerForm.value).subscribe((result:any)=>{
    console.log("ecount:" + result[0]['email']);
    console.log("mcount: " + result[0]['mobile']);

    var ecount = result[0]['email'];
    var mcount = result[0]['mobile'];

    if(0 < ecount || 0 < mcount ){
        alert('This data already Exit');
        this.registerForm.reset();
        return;

    }
    else{
      this.api.regFormApply(this.registerForm.value).subscribe((result:any)=>{
        console.log(result);
      });
      this.submitted = false;
      this.registerForm.reset();
      alert("Sucess");
      this.router.navigateByUrl('/testLogin');
      return;
    }

  });
}

MustMatch(controlName: string, matchingControlName: string) {
  return (formGroup: FormGroup) => {
      const control = formGroup.controls[controlName];
      const matchingControl = formGroup.controls[matchingControlName];

      if (matchingControl.errors && !matchingControl.errors.mustMatch) {
          // return if another validator has already found an error on the matchingControl
          return;
      }

      // set error on matchingControl if validation fails
      if (control.value !== matchingControl.value) {
          matchingControl.setErrors({ mustMatch: true });
      } else {
          matchingControl.setErrors(null);
      }
  }
}

emailCheck(event:any){
  var args= {email: event.target.value };
  this.api.emailCheck(args).subscribe((result:any)=>{
    if(0 < result[0]['email']){
      alert("already email exit");
      this.registerForm.get('email').reset();
      return;
    }

  });
}

mobileCheck(event:any){
  var args= {mobile: event.target.value };
  this.api.mobileCheck(args).subscribe((result:any)=>{
    if(0 < result[0]['mobile']){
      alert("already mobile exit");
      //this.registerForm.reset();
      this.registerForm.get('mobile').reset();

      return;
    }

  });
}


omit_text(event:any)
{
  var k;
   k = event.charCode;
   return((k > 64 && k < 91) || (k > 96 && k < 123) || k==32);
// return((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
}
omit_text_number(event:any)
{
  var k;
   k = event.charCode;
   return((k > 64 && k < 91) || (k > 96 && k < 123) || (k >= 48 && k <= 57) || k==32);
// return((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
}
omit_email(event:any)
{
  var k;
   k = event.charCode;
   return((k > 64 && k < 91) || (k > 96 && k < 123) || k == 46 || k==64 || k==95 || k==32);
}
omit_number(event:any)
{
  var k;
   k = event.charCode;
   return((k >= 48 && k <= 57) || k==32);
// return((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
}
omit_spl(event:any)
{
  var k;
   k = event.charCode;
   return((k > 64 && k < 91) || (k > 96 && k < 123) || (k >= 48 && k <= 57) || k == 47 || k==32);
// return((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
}
omit_addres(event:any)
{
  var k;
   k = event.charCode;
   return((k > 64 && k < 91) || (k > 96 && k < 123) || (k >= 48 && k <= 57) || k==32);
// return((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
}
omit_decimal(event:any)
{
  var k;
   k = event.charCode;
   return((k >= 48 && k <= 57) || k==32 || k == 46);
// return((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
}

public password:string = 'password';
public eye_bool:boolean = false;
public eyeSlash_bool:boolean = true;
eye(){
this.password = 'password';
this.eyeSlash_bool = true;
  this.eye_bool = false;
}
eyeSlash(){
  this.password = 'text'
  this.eyeSlash_bool = false;
  this.eye_bool = true;
}

}
